import React, { useEffect, useState } from 'react';
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
  TextField
} from '@mui/material';
import { Control, Controller, useForm } from 'react-hook-form';
import { validations } from '@shared/infrastructure/ui/validations';
import { Content, ContentKind } from '@shared/domain/content/content.aggregate';

export const ContentSettings = ({
  control,
  disableKind,
  kind
}: {
  control: Control<Content, any>;
  disableKind?: boolean;
  kind: ContentKind;
}) => {
  return (
    <>
      <Controller
        name='kind'
        control={control}
        rules={validations.required()}
        render={({ field, fieldState }) => (
          <FormControl>
            <InputLabel error={!!fieldState.error} id='contents-label'>
              Type
            </InputLabel>
            <Select
              {...field}
              error={!!fieldState.error}
              sx={{ my: '0.3rem' }}
              labelId='contents-label'
              disabled={disableKind}
              input={<OutlinedInput error={!!fieldState.error} label='Type' />}
              renderValue={(value) => <div>{value}</div>}
            >
              <MenuItem key={'Document'} value={'Document'}>
                <div>Document</div>
              </MenuItem>
              <MenuItem key={'Video'} value={'Video'}>
                <div>Video</div>
              </MenuItem>
              <MenuItem key={'Game'} value={'Game'}>
                <div>Game</div>
              </MenuItem>
            </Select>
            <FormHelperText error={!!fieldState.error}>
              {fieldState.error?.message}
            </FormHelperText>
          </FormControl>
        )}
      />
      {kind === 'Game' ? (
        <Controller
          name='url'
          control={control}
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              sx={{ my: '0.3rem' }}
              label='URL'
            />
          )}
        />
      ) : (
        <div>
          <div>
            PDF- and movie-files have to be uploaded from the content list-view.
          </div>
          <div>
            It is recommendet for movies to use the movies first frame as
            thumbnail and not set a thumbnail using the thumbnail URL.
          </div>
        </div>
      )}
    </>
  );
};
